export var DockerStatus;
(function (DockerStatus) {
    DockerStatus["ACTIVE"] = "active";
    DockerStatus["STARTING"] = "starting";
    DockerStatus["RESTARTING"] = "restarting";
    DockerStatus["INACTIVE"] = "inActive";
})(DockerStatus || (DockerStatus = {}));
